export default function Marquee({ items }) {
  const line = items.join("  ·  ");
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden py-8 md:py-10 border-y border-black/10 bg-[#F0EBE1]/60">
      <div className="marquee-track italic-serif text-[clamp(2.25rem,6vw,5rem)] leading-none text-espresso">
        <span>{line}  ·  {line}  ·  </span>
        <span aria-hidden="true">{line}  ·  {line}  ·  </span>
      </div>
    </div>
  );
}
